import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const [PopoverProvider, usePopoverContext] = buildGlobalReferenceContext("Popover");

export { PopoverProvider, usePopoverContext };
//# sourceMappingURL=context.mjs.map
